import React, { Component, useContext, createContext } from 'react';

export const DictContext = createContext<any>(null);
export const useDict = () => {
  return useContext(DictContext);
};
